import { render, staticRenderFns } from "./NavMenus.vue?vue&type=template&id=2f6c0c30&scoped=true&"
import script from "./NavMenus.vue?vue&type=script&lang=js&"
export * from "./NavMenus.vue?vue&type=script&lang=js&"
import style0 from "./NavMenus.vue?vue&type=style&index=0&lang=css&"
import style1 from "./NavMenus.vue?vue&type=style&index=1&id=2f6c0c30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6c0c30",
  null
  
)

export default component.exports